import { logWebHrError } from "@/core/logger/log-wrapper";

export default function cloneObj(obj) {
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch (e) {
    logWebHrError({
      message: 'Failed to clone object',
      source: 'cloneObj',
      error: e,
    });
    return obj;
  }
}
